import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

@IonicPage()
@Component({
  selector: 'page-maintenance',
  templateUrl: 'maintenance.html',
})
export class MaintenancePage {
  public maintenanceMessage: string;
  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    const maintenanceMessage = sessionStorage.getItem('maintenanceMessage');
    if(maintenanceMessage) this.maintenanceMessage = maintenanceMessage;
  }
}



// WEBPACK FOOTER //
// ./src/pages/maintenance/maintenance.ts